'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

var _notificationConstants = require('../../../../../common/notifications/notificationConstants');

// Utils
exports.default = function (_ref) {
    var subject = _ref.subject,
        introduction = _ref.introduction,
        error = _ref.error,
        boardId = _ref.boardId,
        currentUser = _ref.currentUser;
    return 'mailto:' + _notificationConstants.MILANOTE_EMAILS.SUPPORT + '?subject=' + subject + ('&body=Hi Milanote team,\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + introduction + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nPlease contact ' + currentUser.getIn(['name', 'displayName']) + ' at ' + currentUser.get('email') + '.\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nThanks\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nDetails:' + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Time: ' + new Date() + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Board: ' + boardId + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'User: ' + currentUser.get('_id') + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error code: ' + (0, _immutableHelper.prop)('code', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error message: ' + (0, _immutableHelper.prop)('message', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n' + _notificationConstants.URL_ENCODINGS.TAB + 'Error ID: ' + (0, _immutableHelper.prop)('id', error) + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\n');
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/utils/getErrorEmailHref.js
// module id = 697
// module chunks = 0